type Point = {
  x: number;
  y: number;
};

/**
 * Transforms a point to local coordinate space.
 * @param svg The SVG element (the container or graphic elements)
 * @param  point The point to transform (window coordinates)
 */
export function toLocal(svg: SVGSVGElement | SVGElement, point: Point) {
  const parent = svg.ownerSVGElement ?? (svg as SVGSVGElement);

  const pt = parent.createSVGPoint();
  pt.x = point.x;
  pt.y = point.y;

  const screenCTM =
    "getScreenCTM" in svg ? svg.getScreenCTM() : parent.getScreenCTM();

  if (!screenCTM) throw new Error("No screenCTM found!");

  // transform the points from screen coordinates to svg coordinates:
  const svgP = pt.matrixTransform(screenCTM.inverse());

  return {
    x: svgP.x,
    y: svgP.y
  };
}

/**
 * Transforms a point to screen coordinate space.
 * @param svg The SVG element (the container or graphic elements)
 * @param point The point to transform (window coordinates)
 * @returns A point with svg coordinates
 */
export function toScreen(
  svg: SVGElement | SVGSVGElement,
  point: Point,
  getOffset: boolean
) {
  let parent = svg.ownerSVGElement;
  if (parent === null) parent = svg as SVGSVGElement;

  const pt = parent.createSVGPoint();

  const screenCTM =
    "getScreenCTM" in svg ? svg.getScreenCTM() : parent.getScreenCTM();

  let offset = {
    x: 0,
    y: 0
  };
  if (getOffset) {
    offset = pt.matrixTransform(screenCTM ?? undefined);
  }

  pt.x = point.x;
  pt.y = point.y;
  // transform the points from screen coordinates to svg coordinates:
  const svgP = pt.matrixTransform(screenCTM ?? undefined);
  return {
    x: svgP.x - offset.x,
    y: svgP.y - offset.y
  };
}

export default {
  toLocal,
  toScreen
};
